import React, { useEffect, useState } from "react";
import { fetchToolboxTalks } from "../../../views/Safety/toolboxApi";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// "2026-08-13T…" -> "Aug 13"
const prettyDate = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
      })
    : "";

// Compact toolbox talks summary: how many talks are posted and the most
// recent few, so the newest safety video is one click away.
const ToolboxTalksWidget = () => {
  const [talks, setTalks] = useState(null);

  useEffect(() => {
    fetchToolboxTalks()
      .then((data) => setTalks(Array.isArray(data) ? data : []))
      .catch(() => setTalks([]));
  }, []);

  if (talks === null) {
    return (
      <WidgetFrame title="Toolbox Talks" to="/safety/toolbox-talks">
        <WidgetEmpty>Loading talks…</WidgetEmpty>
      </WidgetFrame>
    );
  }

  return (
    <WidgetFrame title="Toolbox Talks" to="/safety/toolbox-talks">
      {talks.length === 0 ? (
        <WidgetEmpty>No toolbox talks posted yet.</WidgetEmpty>
      ) : (
        <div className="space-y-2">
          <WidgetStat value={talks.length} label="talks posted" />
          <ul className="space-y-1.5">
            {talks.slice(0, 3).map((talk) => (
              <li
                key={talk.id}
                className="flex items-center justify-between gap-2 text-sm"
              >
                <span className="truncate">{talk.title}</span>
                <span className="app-muted shrink-0 text-xs">
                  {prettyDate(talk.createdAt)}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </WidgetFrame>
  );
};

export default ToolboxTalksWidget;
